import { Component, OnInit } from '@angular/core';
import { User } from '../../shared/models/user';
import { UserService } from '../../shared/services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
	selector: 'app-verify-store',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
	public newUser = false;
	public user: Partial<User> = {
		_id: null,
		username: null,
		email: null,
		firstName: null,
		lastName: null,
		phoneNumber: null,
		roles: [],
		password: null,
		oldPassword: null,
		imageUrl: null,
		city: null
	};
	// public user: firebase.User;
	messageResponse: {
		type?: string;
		message?: string;
	} = {};
	public passwordresetForm: FormGroup;
	public isError: boolean = false;
	public errorMessage: any;
	private returnRoute;

	constructor(
		private fb: FormBuilder,
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private authService: AuthService,
		private userService: UserService
	) {
		this.passwordresetForm = this.fb.group({
			email: ['', [Validators.required, Validators.email]]
		});
	}

	ngOnInit() {
		this.initReturnUrl();
	}
	Submit() {
		if (this.passwordresetForm.value['email'].length) {
			this.isError = false;
			const email = this.passwordresetForm.value['email'];
			this.userService.forgotpassword(email).subscribe(res => {
				if (res.done) {
					this.messageResponse.type = 'success';
					this.messageResponse.message = res.message;
				} else {
					this.messageResponse.type = 'danger';
					this.messageResponse.message = res.message;
				}
			});
		}
	}

	getNavigationRouteUrlByRole(role: string) {
		let redirectUrl = '/dashboard';
		switch (role) {
			case 'SuperAdmin':
				redirectUrl = 'admin';
				break;
			case 'Admin':
				redirectUrl = 'admin';
				break;
		}
		return redirectUrl;
	}

	initReturnUrl() {
		this.activatedRoute.queryParams.subscribe(res => {
			{
				if (res?.returnUrl) this.returnRoute = res.returnUrl;
				this.checkLogin();
			}
		});
	}

	checkLogin() {
		const user = this.authService.userValue;
		if (user) {
			if (!this.returnRoute) {
				this.returnRoute = this.getNavigationRouteUrlByRole(user.roles[0]);
			}
			this.router.navigate([this.returnRoute]);
		}
	}
}
